import { map } from 'lodash';
import { setPrimaryDoctor } from './actions';
import OtherContactService from './OtherContactService';
import PrimaryDoctorService from './PrimaryDoctorService';
import { currentPatientIdSelector } from '../patient';
import { toAddressRequest } from '../util';

// Helpers
const toOtherContactRequest = (otherContacts, patientId) =>
  map(otherContacts, contact => ({
    ...toPrimaryDoctorRequest(contact, patientId),
    contactRole: contact.contactRole,
  }));

const toPrimaryDoctorRequest = (
  {
    addressId,
    addressState,
    city,
    email,
    fax,
    firstName,
    id,
    lastName,
    phoneExtension,
    practiceName,
    primaryPhoneNumber,
    secondaryStreetAddress,
    streetAddress,
    url,
    contactRole,
    zipCode,
    notes,
  },
  patientId,
) => ({
  ...toAddressRequest({
    addressId,
    addressState,
    city,
    secondaryStreetAddress,
    streetAddress,
    zipCode,
  }),
  email,
  fax,
  firstName,
  id,
  lastName,
  patientId,
  phone: primaryPhoneNumber,
  extension: phoneExtension,
  practiceName,
  website: url,
  contactRole,
  notes,
});

// Thunks
const toRequest = (data, patientId) => ({
  ...toPrimaryDoctorRequest(data, patientId),
  otherContacts: toOtherContactRequest(data.otherContacts, patientId),
});

const fetchPrimaryDoctorAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return Promise.all([
    dispatch(PrimaryDoctorService.getByPatientId(patientId)),
    dispatch(OtherContactService.getByPatientId(patientId)),
  ]).then(([primaryDoctor, otherContacts]) => {
    return dispatch(
      setPrimaryDoctor({
        ...primaryDoctor,
        otherContacts,
      }),
    );
  });
};

const updatePrimaryDoctorAsync = primaryDoctor => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    PrimaryDoctorService.update(
      primaryDoctor.id,
      toRequest(primaryDoctor, patientId),
    ),
  ).then(() => {
    dispatch(setPrimaryDoctor(primaryDoctor));
  });
};

const createPrimaryDoctorAsync = primaryDoctor => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    PrimaryDoctorService.create(toRequest(primaryDoctor, patientId)),
  ).then(() => {
    dispatch(setPrimaryDoctor(primaryDoctor));
  });
};

const savePrimaryDoctorAsync = primaryDoctor => {
  return !!primaryDoctor.id
    ? updatePrimaryDoctorAsync(primaryDoctor)
    : createPrimaryDoctorAsync(primaryDoctor);
};

export { fetchPrimaryDoctorAsync, savePrimaryDoctorAsync };



// WEBPACK FOOTER //
// ./src/lib/dataLayer/primaryDoctor/thunks.js